import isEqual from 'lodash/isEqual';
import { useState, useCallback } from 'react';
// @mui
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// _mock
import { _userList } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable,
    getComparator
} from 'src/components/table';
import UserNewEditForm from './create-form-fields';
//

// ----------------------------------------------------------------------
const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};
// ----------------------------------------------------------------------
export default function NewsLetterCreatePage() {
    const table = useTable();
    const settings = useSettingsContext();
    const confirm = useBoolean();
    const [ tableData, setTableData ] = useState(_userList);
    const [ filters, setFilters ] = useState(defaultFilters);

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered.slice(
        table.page * table.rowsPerPage,
        table.page * table.rowsPerPage + table.rowsPerPage
    );

    const denseHeight = table.dense ? 52 : 72;

    const canReset = !isEqual(defaultFilters, filters);

    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;



    const handleDeleteRows = useCallback(() => {
        const deleteRows = tableData.filter((row) => !table.selected.includes(row.id));
        setTableData(deleteRows);

        table.onUpdatePageDeleteRows({
            totalRows: tableData.length,
            totalRowsInPage: dataInPage.length,
            totalRowsFiltered: dataFiltered.length,
        });
    }, [ dataFiltered.length, dataInPage.length, table, tableData ]);

    return (
        <>
            <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                <CustomBreadcrumbs
                    heading="Newsletter"
                    links={ [
                        { name: '', href: paths.dashboard.root },

                    ] }

                />
                <UserNewEditForm />
            </Container>
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}
// ----------------------------------------------------------------------
function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;
    const stabilizedThis = inputData.map((el, index) => [ el, index ]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[ 0 ], b[ 0 ]);
        if (order !== 0) return order;
        return a[ 1 ] - b[ 1 ];
    });
    inputData = stabilizedThis.map((el) => el[ 0 ]);
    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }
    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }
    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }
    return inputData;
}
